import { getConfig } from './config'

export interface Pricing {
  currency: string
  recurrency: string
  recurrencyPeriod: number
  _id: string
  price: number
}

export interface Plan {
  items: string[];
  status: string;
  isDeleted: boolean;
  _id: string;
  pricing: Pricing[];
  name: string;
  trialPeriod: number;
  updatedAt: Date;
  createdAt: Date;
  __v: number;
  isSubscribed: boolean;
  cancellationEffectiveDate?: Date;
}

export interface PlanOptions {
  status?: 'active' | 'inactive'
}

export const get = async (params: PlanOptions): Promise<Plan[]> => {
  const config = getConfig()
  const response = await config.axios.get<Plan[]>(`${config.API_URL}/plans`, {
    params
  })

  return response.data
}

// export const get = async ({ planId, _id, ...restParams } = {}) => {
//   if (planId || _id) {
//     return axios.get(`${config.API_URL}/plans/${planId || _id}`, { params: restParams })
//   }
//   return axios.get(`${config.API_URL}/plans`, { params: restParams })
// }

// export const save = async ({ planId, _id, ...params }) => {
//   if (planId || _id) {
//     return axios.put(`${config.API_URL}/plans/${planId || _id}`, params)
//   }

//   return axios.post(`${config.API_URL}/plans/`, params)
// }
